export const AFTER_BANKRUPTCY = 'afterBankruptcy';
export const ATTORNEY = 'attorney';
export const ATTORNEY_COST = 'attorneyCost';
export const BANKRUPTCY_FORMS = 'bankruptcyForms';
export const CHAPTER_13 = 'chapter13';
export const CHAPTER_7 = 'chapter7';
export const COURTS = 'courts';
export const CREDIT_COUNSELING = 'creditCounseling';
export const DEBT_COLLECTION = 'debtCollection';
export const DEBT_MANAGEMENT_PLAN = 'debtManagementPlan';
export const DEBTS = 'debts';
export const DECIDING_TO_FILE = 'decidingToFile';
export const EXEMPTIONS = 'exemptions';
export const FILING_ON_MY_OWN = 'filingOnMyOwn';
export const LEGAL_AID = 'legalAid';
export const MEANS_TEST = 'meansTest';
export const PROPERTY = 'property';
export const SUPPORT = 'support';
export const UPSOLVE = 'upsolve';
export const VEHICLES = 'vehicles';
export const WAGE_GARNISHMENT = 'wageGarnishment';